import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";

// import { GLOBAL_MEETING_DATA } from "../../constants/PublicVariables";

import useGetNetworkQuality from "../../hooks/useGetNetworkQuality";
import useLanguageChange from "../../hooks/useLanguageChange";

import { setIsParticipantDrawerOpen, setRemoveParticipant } from "../../reducers/common-reducer";

import RemoteParticipantList from "./RemoteParticipantList";
import LocalParticipantInfo from "./LocalParticipantInfo";
import { isAgentIdentity } from "../../shared/utility";
// import { useFlags } from "launchdarkly-react-client-sdk";
// import { ENABLED } from "../../constants/Constants";
// import { VideoRoomMonitor } from "@twilio/video-room-monitor";
import {
    handleAudioOffForAllParticipantRemotelyByHost,
    handleVideoOffForAllParticipantRemotelyByHost,
} from "./HostControlledParticipants/HostControlledParticipantUtils";
import { isEmpty } from "lodash";
import { useParticipantCounts } from "../../hooks/useParticipantCounts/useParticipantCounts.jsx";
import googleEvent from "../../services/googleEvent.js";
import { EVENT_NAME } from "../../constants/GTagConstants.js";
import { LogFirebase } from "../../services/firestore.js";
import { FIREBASE_EVENT_CATEGORY } from "../../constants/FirebaseConstants.js";

const ParticipantsListDrawer = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();
    const localUserQualityValue = useGetNetworkQuality();
    // const ldFlags = useFlags();
    const { countWithSilentObserver } = useParticipantCounts();
    const {
        isParticipantDrawerOpen,
        newActiveUserList,
        callParticipants,
        remoteParticipantesDeviceInfo,
        partiCountForDisplay,
        isRemoteParticipantJoined,
    } = useSelector((state) => state.commonReducer);
    const { videoIdentityParticipantVise, allAudioTrackIdentity } = useSelector((state) => state.twilioEvents);

    const handleCloseParticipantModal = () => {
        dispatch(setIsParticipantDrawerOpen(false));
    };

    // const isRoomCallLogsAvailable = useMemo(() => {
    //     return GLOBAL_MEETING_DATA.isAgent && (GLOBAL_MEETING_DATA.isRoomCallHasLogsParams == ENABLED || ldFlags?.roomCallLogs);
    // }, [ldFlags]);

    // const openRoomMonitor = () => {
    //     VideoRoomMonitor.openMonitor();
    // };

    const removeAllUserByHost = () => {
        googleEvent.logEvent(EVENT_NAME.REMOVE_ALL_PARTICIPANTS_TAPPED);
        LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "REMOVE_ALL_PARTICIPANTS_TAPPED", "popup_open");
        const removeParticipantData = {
            isRemoveAllModalOpen: true,
            isRemoveModalOpen: false,
            identity: "",
            name: "",
        };
        dispatch(setRemoveParticipant(removeParticipantData));
    };

    useMemo(() => {
        if (videoIdentityParticipantVise) {
            LogFirebase(FIREBASE_EVENT_CATEGORY.HOST_CONTROLLED_PARTICIPANTS, "AllCamsOffEnbledDisabled", {
                videoIdentityParticipantVise: videoIdentityParticipantVise,
                video_count: videoIdentityParticipantVise.length,
            });
        }
    }, [videoIdentityParticipantVise]);

    const handleAllCamsOffEnbledDisabled = () => {
        if (isEmpty(videoIdentityParticipantVise)) {
            return true;
        }
        return false;
    };

    return (
        <div className={clsx("sidebar left-sidebar", isParticipantDrawerOpen && "active")} data-testid='participant-drawer' id='participants-sidebar'>
            <div className='close-in-mobile' onClick={handleCloseParticipantModal} onKeyDown={() => {}}></div>
            <div className='sidebar-in'>
                <div className='sidebar-head'>
                    <div className='sidebar-head-title'>
                        <div className='title'>{localisedValues?.participants_title}</div>
                    </div>
                    <div className='sidebar-head-right'>
                        <div className='participants-control-dropdown'>
                            <div className='dropdown custom-dropdown'>
                                <button
                                    className='btn dropdown-toggle triangle-none participants-control-btn'
                                    type='button'
                                    id='participants-control-dropdown'
                                    data-bs-toggle='dropdown'
                                    aria-expanded='false'
                                >
                                    <span className='for-icon icon-more'></span>
                                </button>
                                <div className='dropdown-menu right' aria-labelledby='participants-control-dropdown'>
                                    <div className='dropdown-menu-in'>
                                        <ul>
                                            <li>
                                                <div className='dropdown-item-div'>
                                                    <button
                                                        className='dropdown-item participants-control-action-btn'
                                                        onClick={handleAudioOffForAllParticipantRemotelyByHost}
                                                        disabled={isEmpty(allAudioTrackIdentity)}
                                                    >
                                                        <span className='for-icon icon-mute-stroke'></span>
                                                        <span className='for-text'>{localisedValues?.turn_all_mics_off}</span>
                                                    </button>
                                                </div>
                                            </li>
                                            <li>
                                                <div className='dropdown-item-div'>
                                                    <button
                                                        className='dropdown-item participants-control-action-btn'
                                                        onClick={handleVideoOffForAllParticipantRemotelyByHost}
                                                        disabled={handleAllCamsOffEnbledDisabled()}
                                                    >
                                                        <span className='for-icon icon-video-off-stroke'></span>
                                                        <span className='for-text'>{localisedValues?.turn_all_cams_off}</span>
                                                    </button>
                                                </div>
                                            </li>
                                            <li>
                                                <div className='dropdown-item-div'>
                                                    <button
                                                        className='dropdown-item participants-control-action-btn'
                                                        onClick={removeAllUserByHost}
                                                        disabled={!isRemoteParticipantJoined || countWithSilentObserver < 2}
                                                    >
                                                        <span className='for-icon icon-remove-user'></span>
                                                        <span className='for-text'>{localisedValues?.remove_all}</span>
                                                    </button>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='sidebar-close'>
                            <button
                                className='btn close-sidebar-button'
                                data-testid='participants-sidebar'
                                onClick={() => handleCloseParticipantModal()}
                            >
                                <span className='for-icon icon-close-light'></span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className='sidebar-body padding-0 custom-scroll'>
                    <div className='participants-list accordion' id='participants-accordion'>
                        <LocalParticipantInfo localUserQualityValue={localUserQualityValue} localisedValues={localisedValues} />
                        {partiCountForDisplay > 1 &&
                            callParticipants.map(
                                (participant, index) =>
                                    !isAgentIdentity(participant?.identity) && (
                                        <RemoteParticipantList
                                            key={participant?.identity}
                                            participant={participant}
                                            index={index}
                                            localisedValues={localisedValues}
                                            newActiveUserList={newActiveUserList}
                                            remoteParticipantesDeviceInfo={remoteParticipantesDeviceInfo}
                                        />
                                    )
                            )}
                    </div>
                </div>
                {/* {isRoomCallLogsAvailable && (
                    <div className='sidebar-foot participant-sidebar-foot'>
                        <div className='button'>
                            <button className='btn btn-with-icon btn-primary view-call-log-btn' onClick={openRoomMonitor}>
                                <span className='btn-icon icon-monitor'></span>
                                <span className='btn-text'>{localisedValues?.view_call_logs}</span>
                            </button>
                        </div>
                    </div>
                )} */}
            </div>
        </div>
    );
};

export default ParticipantsListDrawer;
